import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { Contact } from '@common/models/contact';

@Injectable({ providedIn: 'root' })
export class ContactService{
      /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  getAll() {
    return this._http.get<Contact[]>(`${environment.commonApiUrl}/api/contact`);
  }

  getById(id: number) {
    return this._http.get<Contact>(`${environment.commonApiUrl}/api/contact/${id}`);
  }

  addContact(contact){
    return this._http.post<Contact>(`${environment.commonApiUrl}/api/contact`, contact).pipe(
      map((response: any) => response.contact as Contact),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editContact(contact){
    return this._http.put<Contact>(`${environment.commonApiUrl}/api/contact/${contact.id}`, contact).pipe(
      map((response: any) => response.contact as Contact),
      catchError(e => {
        return throwError(e);
      })
    );
  }
}
